module.exports = __webpack_public_path__ + "img/daneshbonyan.7b7db01.svg";